import React from 'react';
import _ from 'underscore';
import AccountManager from './AccountManager';

class AccountsController extends React.Component {
    constructor (props) {
        super(props)
        this.state = this.props.store();
    }

    componentWillMount () {
        var self = this;

        this.props.onError(function (err) {
            self.props.emitSnack({
                type: 'error',
                message: err.message[0]
            });
        });

        this.removeListener = this.props.store(function onChange (data) {
            self.setState(data);
        });

        this.props.actions.getUser();
    }

    componentWillUnmount () {
        this.removeListener();
    }

    render () {
        return (
            <AccountManager
                {...this.props}
                {...this.state}
                emitSnack={this.props.emitSnack}
                actions={this.props.actions}
                onWorkspaceAction={this.props.onWorkspaceAction}
                user={this.state.user}
                accounts={this.state.accounts}
                keys={this.state.keys}
                clientID={this.props.credentials.clientID}
            />
        );
    }

}

export default AccountsController;
